<script>
import WidgetTitle from '@/components/widgets/widgetTitle'

export default {
  name: 'ActionsWidget',
  components: { WidgetTitle },
  data () {
    return {
      actions: [
        // 'App/showAjoutEnseignant'
        { title: this.$t('action.add-account'), action: 'App/setGlobalDialog', storeValue: this.$store.state.App.globalDialog, context: 'sansRelation' },
        { title: this.$t('action.give-token'), action: 'App/setGlobalDialog', storeValue: this.$store.state.App.globalDialog, context: 'distribution' }
        // { title: this.$t('action.gestion-classe'), action: 'App/setGlobalDialog', storeValue: this.$store.state.App.globalDialog, context: 'classe' }
      ]
    }
  },
  methods: {
    toggleAction (action, value, context) {
      this.$store.commit(action, { value: !value.value, context: context })
    }
  }
}
</script>

<template lang="pug">
  .actions-widget
    WidgetTitle(:title="$t('action.actions-rapides')", transparentBg)
    v-row
      v-col(v-for='(action, index) in actions', :key='index')
        v-card.stylecard(dark, color='secondary', flat, @click='toggleAction(action.action, action.storeValue, action.context)')
          v-card-title {{action.title}}

</template>

<style lang='sass' scoped>
.actions-widget
  .stylecard
    margin: 10px 25px
    .v-card__title
      justify-content: center
</style>
